<template>
  <div>
    <table class="table-condensed table-striped table-bordered">
      <tbody>
        <tr>
          <th style="width: 150px">Chave</th>
          <th style="width: 150px">Valor</th>
        </tr>
        <tr v-for="(value, key) in dataObject" :key="key">
          <td>{{ key }}</td>
          <td>
            <template v-if="key.toLowerCase() === 'sql'">
              <button class="btn btn-sm btn-info" @click="abrirModalSQL(value, key)">
                Ver SQL
              </button>
            </template>
            <template v-else-if="key.toLowerCase() === 'sql_diff'">
              <button class="btn btn-sm btn-info" @click="abrirModalDiffSQL(value)">
                Ver Diff SQL
              </button>
            </template>
            <template v-else>
              {{ value }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>


    <div v-if="exibirModalSQL" class="modal fade show d-block" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">SQL da Consulta</h5>
            <button type="button" class="close" @click="fecharModalSQL">&times;</button>
          </div>
          <div class="modal-body">
            <CodeEditor
              v-model="sqlAtual.sql"
              :readonly="true"
              :scriptMode="'SQL'"
            />
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-primary" @click="copiarSql">Copiar SQL</button>
            <button class="btn btn-sm btn-secondary" @click="fecharModalSQL">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="exibirModalDiffSQL" class="modal fade show d-block" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-xl" style="max-width: 95vw; width: 95vw;">
        <div class="modal-content" style="height: 90vh;">
          <div class="modal-header">
            <h5 class="modal-title">Diff SQL da Consulta</h5>
            <button type="button" class="close" @click="fecharModalDiffSQL">&times;</button>
          </div>
          <div class="modal-body" style="overflow-y: auto; max-height: calc(90vh - 120px);">
            <CodeDiff
              :old-string="currentDiff.old"
              :new-string="currentDiff.new"
              :output-format="'side-by-side'"
              :forceInlineComparison="true"
              :language="'sql'"
            />
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-secondary" @click="fecharModalDiffSQL">Fechar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CodeEditor from "@/components/form/CodeEditor.vue";
import { CodeDiff } from 'v-code-diff'

export default {
  name: "KeyValueTable",
  components: { CodeEditor, CodeDiff },
  props: ['dataObject'],
  data() {
    return {
      exibirModalSQL: false,
      exibirModalDiffSQL: false,
      sqlAtual: {
        sql: null,
        index: null
      },
      diffs: [],
      currentDiff: {
        old: null,
        new: null
      }
    };
  },
  methods: {
    abrirModalSQL(sql, index) {
      this.sqlAtual = { sql, index };
      this.exibirModalSQL = true;
    },
    fecharModalSQL() {
      this.exibirModalSQL = false;
      this.sqlAtual = {
        sql: null,
        index: null
      };
    },
    abrirModalDiffSQL(diff) {
      this.currentDiff = {
        old: diff.dados_anteriores || '',
        new: diff.dados_novos || ''
      };
      this.exibirModalDiffSQL = true;
    },
    fecharModalDiffSQL() {
      this.exibirModalDiffSQL = false;
      this.currentDiff = {
        old: null,
        new: null
      };
    },
    copiarSql() {
      navigator.clipboard.writeText(this.sqlAtual.sql);
    },
  },
}
</script>

<style scoped>
  table td, table th {
    padding: 2px;
    word-wrap: anywhere;
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
</style>
